<template>
    <div
        v-show="isVisible"
        :ref="refDropdown"
        class="email-input-dropdown"
        :class="dropdownClass"
        :style="{ minWidth: `${minWidth}px` }"
    >
        <div ref="emailInputDropdownContent" class="email-input-dropdown__content">
            <ul v-show="!loading" class="email-input-dropdown__content-options-container">
                <slot></slot>
            </ul>
            <div class="email-input-dropdown__content--loading">
                <CompassLoader v-if="loading" color="common-icon-neutral" />
            </div>
        </div>
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import generateHash from 'Helpers/hashGenerator.js';

export default {
    name: 'EmailInputDropdown',
    props: {
        minWidth: {
            type: Number,
            default: 0,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        dropdownClass: {
            type: String,
            default: '',
        },
        parentRef: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            popperInstance: null,
            hash: '',
            isWaitingForMoreOptions: false,
        };
    },
    computed: {
        refDropdown() {
            return `emailInputDropdownRef-${this.hash}`;
        },
    },
    watch: {
        isVisible(val) {
            if (val) {
                this.updatePopper();
            }
        },
    },
    created() {
        this.hash = generateHash();
    },
    mounted() {
        this.updatePopper();
    },
    beforeDestroy() {
        if (document.body.contains(document.querySelector('#email-input-dropdown-container'))) {
            document
                .querySelector('#email-input-dropdown-container')
                .removeChild(this.$refs[this.refDropdown]);
        }
    },
    methods: {
        initPopper() {
            if (
                !document.body.contains(document.querySelector('#email-input-dropdown-container'))
            ) {
                const container = document.createElement('div');
                container.id = 'email-input-dropdown-container';
                document.body.appendChild(container);
            }
            document
                .querySelector('#email-input-dropdown-container')
                .appendChild(this.$refs[this.refDropdown]);

            this.popperInstance = createPopper(
                this.$parent.$refs[this.parentRef], // trigger element
                this.$refs[this.refDropdown], // element to be in popper
                {
                    placement: 'bottom-start',
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 4],
                            },
                        },
                    ],
                },
            );
        },
        updatePopper() {
            if (!this.popperInstance) {
                this.initPopper();
            } else {
                this.popperInstance.update();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.email-input-dropdown {
    background: var(--colors-common-background-default);
    border-radius: 4px;
    box-shadow: 0px 0px 8px 0px #11111133;
    left: 0;
    overflow-y: auto;
    padding: var(--spacing-1);
    position: absolute;
    top: calc(100% + 8px);
    width: 312px;
    z-index: 1000;

    &__content {
        display: flex;
        flex-direction: column;
        max-height: 312px;
        overflow-y: auto;

        &--loading {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__content-options-container {
        list-style: none;
        margin: 0;
        min-width: fit-content;
        padding: 0;
    }
}
</style>
